import axios from 'axios'

import {
    ApiResponse,
    PayrollPeriodResource,
    PayrollPeriodViewModel,
} from '../../models'
import UpToButExcludingDate from '../date/UpToButExcludingDate'

const transformApiParamsToPayrollPeriod = (
    params: PayrollPeriodResource,
): PayrollPeriodViewModel => ({
    type: 'payrollPeriods',
    id: params.id,
    year: params.year,
    periodNumber: params.periodNumber,
    start: new Date(params.start),
    end: new UpToButExcludingDate(params.end).transformToUpToAndIncludingDate(),
    locked: params.locked,
})

export const getPayrollPeriods = async (): Promise<PayrollPeriodViewModel[]> => {
    const response = await axios
        .get(`${process.env.REACT_APP_API_URL}/payroll-periods`, {
            params: {
                orderByStart: JSON.stringify({ start: 'ASC' }),
            },
        }) as unknown as ApiResponse<PayrollPeriodResource[]>

    return response.data.map((payrollPeriod) => transformApiParamsToPayrollPeriod(payrollPeriod))
}
